import { Component, OnInit, Input } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { take } from 'rxjs/operators';
//import * as NameActions from './../../../store/actions/name.action';
import * as CompoundNameActions from './../../../store/actions/compoundname.action'
import * as RoleActions from './../../../store/actions/role.action';
import * as ContainsActions from './../../../store/actions/contains.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';

@Component({
  selector: 'app-rec-alpha-search-header',
  providers: [RecSearchService],
  templateUrl: './rec-alpha-search-header.component.html',
  styleUrls: ['./rec-alpha-search-header.component.css']
})
export class RecAlphaSearchHeaderComponent implements OnInit {

  recs: any;
  @Input() recordCount: number;
  lastname: string;
  firstname: string;
  roleId: number;
  contains: number
  
  constructor(private router: Router, private store: Store<AppState>, public nav: NavMenuService, private service: RecSearchService) {

    this.store.select(getRegSearchState).pipe(take(1)).subscribe(data => {
      this.recs = data;
      this.lastname = this.recs.name.name[0].lastcorpName;
      this.firstname = this.recs.name.name[0].fName;
      this.roleId = this.recs.role.role[0].roleId;
      this.contains = this.recs.contains.contains[0].contains;
      console.log('alpha search hdr ' + this.recs.name.name[0].lastcorpName + ' ' + this.recs.name.name[0].fName + ' ' + this.recs.contains.contains[0].contains);

    });


  }

  ngOnInit() {

      //for (let city of this.recs.city[0].citytowns) {
      //  if (city.isChecked)
      //    this.towns.push(city.townName);
      //}

  }

  back(url) {

    this.store.select(getRegSearchState).subscribe(data => this.recs = data);
    //console.log('alpha search hdr back ' + this.recs.name[0].lastcorpName + ' ' + this.recs.name[0].fName + ' ' + this.recs.contains[0].contains);
    //console.log('alpha search hdr back ' + this.lastname + ' ' + this.firstname + ' ' + this.roleId + ' ' + this.contains);

    ////put in store data
    //this.delRecFromStore(0);

    //this.addRecToStore(
    //  this.firstname, //this.recs.name[0].fName, //first name
    //  this.lastname, //last name
    //  this.roleId, //this.roleChild.utilityobj.roleID,
    //  this.contains, //this.containsChild.utilityobj.contains,
    //  '', //this.compoundNameChild2.utilityobj.fName2,
    //  '', //this.compoundNameChild2.utilityobj.lastcorpName2,
    //  0, //this.roleChild2.utilityobj.roleID2,
    //  new Date('1/1/1962'), //this.dateRangeChild.utilityobj.fromDate,
    //  new Date(), //this.dateRangeChild.utilityobj.toDate,
    //  '', //this.cityTownChild.utilityobj.citytowns,
    //  '');  //this.docTypeChild.utilityobj.doctypes);

    //console.log('alpha search hdr back2 ' + this.recs.name[0].lastcorpName + ' ' + this.recs.name[0].fName + ' ' + this.recs.contains[0].contains);

    try {
      this.service.logInfo('Clicked back button');
      this.nav.show();
      if (localStorage.getItem('recNameSearchResults') !== null) {
        localStorage.removeItem('recNameSearchResults');
      }
      this.router.navigate([url]);
    }
    catch (error) {
      this.service.logError(error);
    }

  }

  ngOnDestroy() {
    this.nav.show();
  }

  addRecToStore(fname, lname, role, Contains, fname2, lname2, role2, fromdate, todate, citytowns, doctypes) {

    console.log('add rec ' + lname + ' ' + fname);

    this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname,
      lastcorpName: lname
    }));

    this.store.dispatch(new RoleActions.AddRole({
      roleID: role
    }));

    console.log('Contains - ' + Contains);

    this.store.dispatch(new ContainsActions.AddContains({
      contains: Contains
    }));

    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));

    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocTypeActions.AddDoct({
      doctypes: doctypes
    }));
  }

  delRecFromStore(index) {
    //console.log('del rec');
    this.store.dispatch(new CompoundNameActions.RemoveName(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new ContainsActions.RemoveContains(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  }



}
